import { RootState } from "../reducers"

export const selectFullMatsnetLeaderboard = (state: RootState) =>
  state.matsnet.fullLeaderboard

export const selectIsMatsnetLeaderboardFullyFetched = (state: RootState) =>
  state.matsnet.isFullyFetched

export const selectMatsnetUsersCount = (state: RootState) => state.matsnet.users

export const selectMatsnetUserRank = (state: RootState) =>
  state.matsnet.userRank
